import { useQuery } from '@tanstack/react-query';

import { getBracketQuery } from '@shared/queries/bracket';
import { getLibraryContentQuery } from '@shared/queries/common';
import type { BracketResponse, BracketRound } from '@shared-types/bracket.types';
import { IS_TEST } from '@utilities/browser';
import { getParameterByName } from '@utilities/url';
import { competitionUrl } from '@utilities/WindowContext';

export function useBracket(competitionId: string, seasonYear: string, structureFetched: boolean) {
  const bracketStep = getParameterByName('bracketStep');

  const bracketQuery = bracketStep
    ? getLibraryContentQuery<BracketResponse>(
        `/${competitionUrl}/fixtures-results/libraries/_bracket-data_${bracketStep}`,
      )
    : getBracketQuery({ competitionId, seasonYear });

  const { data: bracket, isFetched } = useQuery<BracketResponse, unknown, BracketRound[]>({
    ...bracketQuery,
    queryKey: ['bracket', competitionId, seasonYear],
    select: (response) => response.data,
    enabled: !!structureFetched,
    refetchInterval: !IS_TEST && 10000,
    placeholderData: { data: [] },
  });

  return { bracket, isFetched };
}
